$(function() {
  // FAQ icons rotation

  document.querySelectorAll(".df-faq__item__content").forEach((el) => {
    el.addEventListener("show.bs.collapse", (e) => {
      if (el === e.target) {
        $(el)
          .parent()
          .find(".df-faq__item__header__icon")
          .addClass("df-rotate--90");
      }
    });

    el.addEventListener("hide.bs.collapse", (e) => {
      if (el === e.target) {
        $(el)
          .parent()
          .find(".df-faq__item__header__icon")
          .removeClass("df-rotate--90");
      }
    });
  });

  // Автокролл к вопросу в FAQ
  const urlParams = new URLSearchParams(window.location.search);
  const faqItemId = urlParams.has('item') ? urlParams.get('item') : null;
  const faqItemQuestionId = urlParams.has('question') ? urlParams.get('question') : null;

  if (typeof faqItemId === 'string') {
    let faqQuestionEl$;
    if (typeof faqItemQuestionId === 'string') {
      faqQuestionEl$ = $(`.df-faq__item__questions__item__header[data-bs-target="#df-faq__item__questions__item__content-${faqItemId}-${faqItemQuestionId}"]`);
    } else {
      faqQuestionEl$ = $(`.df-faq__item__header[data-bs-target="#df-faq__item__content-${faqItemId}-${faqItemQuestionId}"]`);
    }
    console.log(faqQuestionEl$);
    if (faqQuestionEl$ && faqQuestionEl$.length) {
      $("html, body").animate(
        { scrollTop: faqQuestionEl$.parent().offset().top },
        600
      );
    }
  }
});
